"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styleForSp = exports.getParam = exports.getErrorMessage = exports.getResetToken = exports.getError = exports.getSendMailStatus = exports.SEND_MAIL_EXPIRED = exports.SEND_MAIL_ERROR = exports.SEND_MAIL_SUCCESS = exports.SEND_MAIL_BEFORE = exports.validationRules = void 0;
exports.validationRules = {
    username: {
        required: {
            value: true,
            message: "必須項目を入力してください。",
        },
    },
    password: {
        required: {
            value: true,
            message: "必須項目を入力してください。",
        },
    },
    email: {
        required: {
            value: true,
            message: "メールアドレスを入力してください。",
        },
        pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
            message: "メールアドレスの形式で入力してください。",
        },
    },
};
exports.SEND_MAIL_BEFORE = 0;
exports.SEND_MAIL_SUCCESS = 1;
exports.SEND_MAIL_ERROR = 2;
exports.SEND_MAIL_EXPIRED = 3;
var getSendMailStatus = function () {
    var _a;
    var element = document.getElementById("app");
    var status = (_a = element === null || element === void 0 ? void 0 : element.dataset) === null || _a === void 0 ? void 0 : _a.sendStatus;
    if (status === "success")
        return exports.SEND_MAIL_SUCCESS;
    if (status === "failure")
        return exports.SEND_MAIL_ERROR;
    if (status === "expired")
        return exports.SEND_MAIL_EXPIRED;
    return exports.SEND_MAIL_BEFORE;
};
exports.getSendMailStatus = getSendMailStatus;
var getError = function () {
    var element = document.getElementById("app");
    // 要素を取得できない場合は店舗側と判断する
    if (element === null) {
        return;
    }
    var error = element.dataset.errorUsername;
    return error;
};
exports.getError = getError;
/**
 * @returns string
 */
var getResetToken = function () {
    var element = document.getElementById("root");
    if (element === null) {
        return "";
    }
    var resetToken = element.dataset.resetToken;
    if (resetToken === undefined) {
        return "";
    }
    return resetToken;
};
exports.getResetToken = getResetToken;
var getErrorMessage = function () {
    var element = document.getElementById("root");
    if (element === null) {
        return "";
    }
    var errorMessage = element.dataset.errorMessage;
    if (errorMessage === undefined) {
        return "";
    }
    return errorMessage;
};
exports.getErrorMessage = getErrorMessage;
var getParam = function (name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!results)
        return "";
    if (!results[2])
        return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
exports.getParam = getParam;
exports.styleForSp = {
    padding: "0 24px",
};
